import styled from "styled-components";

export const StyledMatchTime = styled.div`
  font-family: ${(props) => props.theme.figma.base.fontfamily_mlstifo_micro};
  font-size: ${(props) => props.theme.mixins.pxToRem(11)};
  color: #868686;
  line-height: ${(props) => props.theme.figma.base.scale_2}px;
  font-weight: 500;
  width: ${(props) => props.theme.figma.base.scale_7_50}px;
  display: flex;

  .mls-c-status-stamp__status {
    max-width: ${(props) => props.theme.figma.base.scale_7}px;
  }
`;
